import { Box, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import CommonHeading from "../../components/commonComponents/commonHeading";
import CustomTextField from "../../components/commonComponents/TextFieldComponent";
import ButtonComponents from "../../components/commonComponents/ButtonComponents";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { AppDispatch } from "../../redux/types";
import {
  getInvestorProfile,
  updateInvestorProfile,
} from "../../redux/slice/userSlice";
import { useAuth } from "../../services/AuthContext";
import { toast } from "react-toastify";
import Loading from "../../components/Loading";
import { formatPhonedata } from "../../utils/formatUtils";
import { BackButton } from "../../components/commonComponents/BackButton";
import { useMsal } from "@azure/msal-react";

export const Profile = () => {
  const [user, setState] = useState({
    firstName: "",
    lastName: "",
    city: "",
    state: "",
    email: "",
    mobilePhone: "",
    mobilePhone2: "",
    streetAddress1: "",
    zipCode: "",
    streetAddress2: "",
    otherPhone: "",
  });
  const [isEditing, setIsEditing] = useState(false);
  const dispatch = useDispatch<AppDispatch>();
  const {
    investorId: { investorId },
  } = useAuth();
  const userProfile = useSelector((store: RootState) => store.user.userProfile);
  const { loadingProfile, loadingUpdate, loginUserDetails } = useSelector(
    (store: RootState) => store.user
  );
  const [disable, setDisable] = useState<any>({
    contact: true,
    address: true,
  });

  const { instance } = useMsal();
  const msalInstance: any = instance;


  const getBidderProfile = () => {
    dispatch(getInvestorProfile(investorId)).then((response) => {
      const userData = response?.payload?.body;
      if (userData) {
        setState((prev) => ({
          ...prev,
          firstName: userData.firstName ||  msalInstance.getActiveAccount()?.idTokenClaims?.given_name || "",
          lastName: userData.lastName || msalInstance.getActiveAccount()?.idTokenClaims?.family_name || "",
          city: userData.city || "",
          state: userData.state || "",
          email: userData.email || "",
          mobilePhone: userData.mobilePhone || "",
          mobilePhone2: userData.mobilePhone2 || "",
          streetAddress1: userData.streetAddress1 || "",
          zipCode: userData.zipCode || "",
          streetAddress2: userData.streetAddress2,
          otherPhone: userData.otherPhone || "",
        }));
      }
    });
  }
  useEffect(() => {
    getBidderProfile()
  }, [dispatch]);

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
  
    // Define max lengths for phone fields
    const maxLengths: { [key: string]: number } = {
      mobilePhone: 10,
      mobilePhone2: 10,
      otherPhone: 10,
    };
  
    let trimmedValue = value;
  
    // Handle phone number fields (mobilePhone, mobilePhone2, otherPhone)
    if (['mobilePhone', 'mobilePhone2', 'otherPhone'].includes(name)) {
      // Remove non-numeric characters
      trimmedValue = value.replace(/[\s(),-]/g, "");
  
      // Enforce max length for phone numbers
      if (trimmedValue.length > maxLengths[name]) {
        trimmedValue = trimmedValue.substring(0, maxLengths[name]);
      }
  
      // Handle contact disabling logic based on phone numbers
      const isMobilePhoneValid = name === "mobilePhone" && trimmedValue.length <= 9;
      const isOtherPhoneValid = (name === "mobilePhone2" || name === "otherPhone") && trimmedValue.length > 0 && trimmedValue.length <= 9;
  
      setDisable((prevState: any) => ({
        ...prevState,
        contact: (isMobilePhoneValid || isOtherPhoneValid),
      }));
    } else {
      // For non-phone fields, reset contact state to false
      setDisable((prevState: any) => ({
        ...prevState,
        contact: true,
      }));
    }
  
    // Update state with the trimmed value
    setState((prev) => ({
      ...prev,
      [name]: trimmedValue,
    }));
  };
  
  const handleUpdateUserContact = async () => {
    const { zipCode, streetAddress1, streetAddress2, city, state, id } =
      userProfile;
    const payload = {
      ...user,
      id,
      investorId,
      zipCode,
      streetAddress1,
      streetAddress2,
      state,
      city,
    };
    const response = await dispatch(updateInvestorProfile(payload)).unwrap();
    if (response.statusCode === 200) {
      getBidderProfile()
      toast.success("Profile information updated successfully", {
        className: 'custom-toast'
      });
      setIsEditing(false);
    }
  };
  const handleEditToggle = () => {
    setIsEditing((prev) => !prev); // Toggle edit mode
  };

  return (
    <>
    <div className='flex justify-start items-center'>
    </div>
    <Box bgcolor={"#f8f8f8"} className="space-y-5">
      <Helmet>
        <title>{`xBid | MyProfile`}</title>
        <meta name="description" content={``} />
      </Helmet>
      <CommonHeading sx={{ mb: 2, fontWeight: "600", fontSize: 22,mt:{sm:"20px",md:"0px",xs:"2px"} }} heading={"My Profile"} />
      {(loadingProfile || loadingUpdate) ? (
        <Loading height="500px"/>
      ) : (
        <>
          <Box p={2} bgcolor={"#fff"} borderRadius={1}>
            <Typography
              sx={{ fontSize: 18, mb: 1, fontWeight: 500 }}
              data-testid="personal-info-title"
            >
              Contact Information
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <CustomTextField
                  label="First Name"
                  name="firstName"
                  value={user.firstName}
                  onChange={handleInputChange}
                  size="big"
                  disabled={!isEditing}
                />
              </Grid>
              <Grid item xs={6}>
                <CustomTextField
                  label="Last Name"
                  name="lastName"
                  value={user.lastName}
                  onChange={handleInputChange}
                  size="big"
                  disabled={!isEditing}
                />
              </Grid>
              {/* Need to add one more box container */}
              
              <Grid item xs={6}>
                <CustomTextField
                  readOnly
                  label="Email Address"
                  name="email"
                  value={user.email}
                  onChange={handleInputChange}
                  size="big"
                  disabled={!isEditing}
                />
              </Grid>
              <Grid item xs={6}>
                <CustomTextField
                  label="Mobile Number"
                  name="mobilePhone"
                  value={formatPhonedata(user.mobilePhone)}
                  onChange={handleInputChange}
                  size="big"
                  disabled={!isEditing}
                />
              </Grid>

              <Grid item xs={6}>
                <CustomTextField
                  label="Alternate Mobile Number (Optional)"
                  name="mobilePhone2"
                  value={formatPhonedata(user.mobilePhone2)}
                  onChange={handleInputChange}
                  size="big"
                  disabled={!isEditing}
                />
              </Grid>

              <Grid item xs={6}>
                <CustomTextField
                  label="Other Number (Optional)"
                  name="otherPhone"
                  value={formatPhonedata(user.otherPhone)}
                  onChange={handleInputChange}
                  size="big"
                  disabled={!isEditing}
                />
              </Grid>
            </Grid>
            <Box
              display={"flex"}
              mt={{ xs: 2, md: 2 }}
              justifyContent={{ xs: "center", md: "end" }}
            >
              {isEditing && (
                <ButtonComponents
                  variant="outlined"
                  sx={{ px: 3, mr: 0, fontSize: "16px", ml: 2 }}
                  label="Cancel"
                  onClick={handleEditToggle} // Cancel edit mode
                  datatestid="cancel edit"
                />
              )}
              <ButtonComponents
                sx={{ px: 3, mr: 0, fontSize: "16px" }}
                label={isEditing ? "Update" : "Edit"} // Change button text
                disabled={isEditing ? disable.contact :  false} // Disable if not editing
                onClick={isEditing ? handleUpdateUserContact : handleEditToggle} // Handle the appropriate action
                datatestid="update profile"
              />
            </Box>
          </Box>

          {/* <Box p={2} bgcolor={"#fff"} borderRadius={1}>
            <Typography
              sx={{ fontSize: 18, mb: 1, fontWeight: 500 }}
              data-testid="personal-info-title"
            >
              Address
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <CustomTextField
                  label="Street Address 1"
                  name="streetAddress1"
                  value={user.streetAddress1}
                  onChange={handleInputChangeAddress}
                  size="big"
                />
              </Grid>
              <Grid item xs={6}>
                <CustomTextField
                  label="Street Address 2 (optional)"
                  name="streetAddress2"
                  value={user.streetAddress2}
                  onChange={handleInputChangeAddress}
                  size="big"
                />
              </Grid>
              <Grid item xs={4}>
                <CustomTextField
                  label="City"
                  name="city"
                  value={user.city}
                  onChange={handleInputChangeAddress}
                  size="big"
                />
              </Grid>
              <Grid item xs={4}>
                <CustomSelectField
                  label="State"
                  name={"state"}
                  size={"big"}
                  options={states}
                  value={user.state}
                  onChange={handleInputChangeAddress}
                  data-testid="state-field"
                  error={""} // Required: Provide error condition
                  helperText={""} // Required: Show error message
                  isDocument={false} // Required: Example value (adjust based on component logic)
                  disabled={false} // Optional: Set disabled state
                  required={true} // Optional: Set required state
                  aria-labelledby="state-select-label" 
                />
              </Grid>

              <Grid item xs={4}>
                <CustomTextField
                  label="Zip Code"
                  name="zipCode"
                  value={user.zipCode}
                  onChange={handleInputChangeAddress}
                  size="big"
                />
              </Grid>
            </Grid>
            <Box
              display={"flex"}
              mt={{ xs: 2, md: 2 }}
              justifyContent={{ xs: "center", md: "end" }}
            >
              <ButtonComponents
                sx={{ px: 3, mr: 0, fontSize: "16px" }}
                label={"Update"}
                disabled={disable.address ? true : false}
                onClick={handleUpdateUserAddress}
                datatestid="update profile"
              />
            </Box>
          </Box> */}
        </>
      )}
    </Box>
    </>
  );
};
